import initializeRepairForm from './../repair-form/_form';

document.addEventListener('DOMContentLoaded', () => {
  initializeRepairForm(document.querySelector('form.repair-form'));
});
